import { render, staticRenderFns } from "./ReferralWelcomeDialog.vue?vue&type=template&id=a9b37ae0"
import script from "./ReferralWelcomeDialog.vue?vue&type=script&lang=js"
export * from "./ReferralWelcomeDialog.vue?vue&type=script&lang=js"
import style0 from "./ReferralWelcomeDialog.vue?vue&type=style&index=0&id=a9b37ae0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports